var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{staticClass:"icon mdi",class:[
    'mdi-' + _vm.name,
    _vm.color,
    _vm.size && 'mdi-' + _vm.size + 'px',
    _vm.rotate && 'mdi-rotate-' + _vm.rotate,
    _vm.flip && 'mdi-flip-' + _vm.flip,
    _vm.spin && 'mdi-spin'
  ],attrs:{"click":_vm.click}})}
var staticRenderFns = []

export { render, staticRenderFns }